import { render, staticRenderFns } from "./StickyDonateBar.vue?vue&type=template&id=2f4ab1d8&scoped=true&"
import script from "./StickyDonateBar.vue?vue&type=script&lang=js&"
export * from "./StickyDonateBar.vue?vue&type=script&lang=js&"
import style0 from "./StickyDonateBar.vue?vue&type=style&index=0&id=2f4ab1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ab1d8",
  null
  
)

export default component.exports